import { INCEPTION_MEMBERSHIP_NOTE } from './nvidia-inception';
import { INSIGHT_ARTICLE_PREFIX, type RouteMeta } from '../config/routes';
import type { SitePost } from '../features/insights/insight-types';

/** Articles hosted on this site at /insights/<slug>. */
export const SITE_POSTS: readonly SitePost[] = [
  {
    slug: 'retax360-joins-nvidia-inception',
    title: 'ReTax360 joins NVIDIA Inception',
    excerpt: INCEPTION_MEMBERSHIP_NOTE,
    category: 'company-news',
    date: '2026-10-26',
    readTime: '1 min read',
    body: `<p>${INCEPTION_MEMBERSHIP_NOTE}</p>`,
  },
];

export const findSitePost = (slug: string): SitePost | undefined => SITE_POSTS.find((post) => post.slug === slug);

/** Route metadata for an article: used by the router and by the build (HTML shells, sitemap). */
export const sitePostMeta = (post: SitePost): RouteMeta => ({
  path: `${INSIGHT_ARTICLE_PREFIX}${post.slug}`,
  pageName: 'insights',
  title: `${post.title} | ReTax360 Insights`,
  description: post.excerpt,
});
